export class Transaction {
    id: number = 0;
    label: string = '';
    date: Date = new Date();
    amount: number = 0
    category: number = 1;
}